module.exports = __webpack_public_path__ + "static/IMG_2676-05dead5990b860dc1475defcfc4bdea0.jpg";